import type en from '../en/devices'
import type { Translation } from '../types'

/** The device brands: registering a device and its page */
const devices: Translation<typeof en> = {
  "devices.registered": "Dispositivo registrado",
  "devices.registrationFailed": "Error en el registro",
  "devices.siteRegistered": "{name} registrado",
  "devices.registerAnother": "Registrar otro",
  "devices.openDevice": "Abrir dispositivo",
  "devices.viewAllSites": "Ver todos los sitios",
  "devices.deviceAddress": "Dirección del dispositivo *",
  "devices.username": "Nombre de usuario *",
  "devices.password": "Contraseña *",
  "devices.siteName": "Nombre del sitio",
  "devices.connectRegister": "Conectar y registrar",
  "devices.directDevice": "Dispositivo directo",
  "devices.deviceUrl": "URL del dispositivo *",
  "devices.reachableVpn": "Debe ser accesible desde este servidor — normalmente a través del túnel VPN.",
  "devices.storedEncrypted": "Se guarda cifrado.",
  "devices.imported": { one: "{count} dispositivo importado", other: "{count} dispositivos importados" },
  "devices.mikrotik.transport.rest": "API REST (RouterOS 7)",
  "devices.mikrotik.transport.apiSsl": "Protocolo API sobre TLS",
  "devices.mikrotik.transport.api": "Protocolo API (sin cifrar)",
  "devices.mikrotik.radios": { one: "{count} radio", other: "{count} radios" },
  "devices.mikrotik.connectedOver": "Conectado mediante: {transport}",
  "devices.mikrotik.registerTitle": "Registrar MikroTik",
  "devices.mikrotik.registerSubtitle": "Un router, punto de acceso o radio punto a punto / punto a multipunto",
  "devices.mikrotik.addressHint": "Debe ser accesible desde este servidor — normalmente su dirección VPN. El tipo de conexión se detecta: REST en RouterOS 7, el servicio API (8729 u 8728) en RouterOS 6.43 y posteriores.",
  "devices.mikrotik.forceHint": "Para forzar uno, escriba",
  "devices.or": "o",
  "devices.mikrotik.accountHint": "Use una cuenta con todos los permisos si quiere configurar el dispositivo desde aquí; para la monitorización basta una cuenta de solo lectura. Se guarda cifrado.",
  "devices.mikrotik.siteNameHint": "(opcional — por defecto, la identidad del dispositivo)",
  "devices.mikrotik.siteNamePlaceholder": "p. ej. Sector norte",
  "devices.mikrotik.radioLinkTitle": "Para un radioenlace",
  "devices.mikrotik.radioLinkText": ", registre cada extremo como un sitio propio. El punto de acceso muestra entonces cada estación con su señal y velocidad; una estación que también esté registrada aquí se reconoce como enlace incluso en un punto de acceso Wi-Fi normal.",
  "devices.peplink.foundOrgs": { one: "{count} organización encontrada", other: "{count} organizaciones encontradas" },
  "devices.peplink.discoveryFailed": "Error en la búsqueda",
  "devices.peplink.telemetryNote": "La telemetría de SpeedFusion y WAN aparece tras la primera sincronización.",
  "devices.peplink.registerTitle": "Registrar Peplink",
  "devices.peplink.registerSubtitle": "Conectar mediante InControl2 o directamente a un router",
  "devices.peplink.ic2Desc": "Importa todos los dispositivos de una organización o grupo.",
  "devices.peplink.directDesc": "Consulta un router Balance/MAX de forma local.",
  "devices.peplink.clientId": "ID de cliente *",
  "devices.peplink.clientSecret": "Secreto de cliente *",
  "devices.createUnder": "Créelo en",
  "devices.peplink.ic2Url": "URL de la API de IC2",
  "devices.peplink.discoverOrgs": "Buscar organizaciones",
  "devices.peplink.organisation": "Organización *",
  "devices.peplink.group": "Grupo",
  "devices.peplink.blankAllGroups": "(vacío = todos los grupos)",
  "devices.peplink.allGroups": "Todos los grupos",
  "devices.peplink.siteNamePlaceholder": "p. ej. Barco 1 — MAX Transit",
  "devices.teltonika.importedFromRms": { one: "{count} dispositivo importado de RMS", other: "{count} dispositivos importados de RMS" },
  "devices.teltonika.telemetryNote": "La telemetría móvil empezará a aparecer tras la primera sincronización.",
  "devices.teltonika.registerTitle": "Registrar Teltonika",
  "devices.teltonika.registerSubtitle": "Conectar mediante la nube RMS o directamente a un router",
  "devices.teltonika.rmsCloud": "Nube RMS",
  "devices.teltonika.rmsDesc": "Importa todos los dispositivos de su empresa en RMS. Ideal para flotas.",
  "devices.teltonika.directDesc": "Consulta un router RutOS mediante su API local.",
  "devices.teltonika.pat": "Token de acceso personal *",
  "devices.teltonika.createInRms": "Créelo en RMS en",
  "devices.teltonika.rmsUrl": "URL de la API de RMS",
  "devices.teltonika.defaultRms": "Déjelo en blanco para el RMS público predeterminado.",
  "devices.teltonika.siteNamePlaceholder": "p. ej. Furgoneta 3 — RUTX11",
  "devices.unifihost.consoles": { one: "{count} consola", other: "{count} consolas" },
  "devices.unifihost.found": "Se han encontrado {consoles} y {sites}",
  "devices.unifihost.verificationFailed": "Error en la verificación",
  "devices.unifihost.importedSites": { one: "{count} sitio importado", other: "{count} sitios importados" },
  "devices.unifihost.importFailed": "Error en la importación",
  "devices.unifihost.doneNote": "Site Manager ofrece telemetría de la flota y métricas del ISP de solo lectura. Para la configuración, añada también el controlador local como sitio UniFi.",
  "devices.unifihost.importMore": "Importar más",
  "devices.unifihost.title": "Conectar UniFi Site Manager",
  "devices.unifihost.subtitle": "Monitorización de toda la flota en cada consola UniFi de su cuenta",
  "devices.unifihost.apiKey": "Clave de API *",
  "devices.unifihost.apiKeyPlaceholder": "Clave de API de UniFi Site Manager",
  "devices.unifihost.createAt": "Créela en",
  "devices.unifihost.baseUrl": "URL base de la API",
  "devices.unifihost.verifyDiscover": "Verificar y buscar",
  "devices.unifihost.importAs": "Importar como",
  "devices.unifihost.perSite": "Un sitio por cada sitio UniFi",
  "devices.unifihost.recommended": "{sites} — recomendado",
  "devices.unifihost.perConsole": "Un sitio por consola",
  "devices.unifihost.consolesToImport": "Consolas que importar",
  "devices.unifihost.console": "consola",
  "devices.unifihost.importConsoles": { one: "Importar {count} consola", other: "Importar {count} consolas" },
  "devices.velanox.registeredFromEndpoint": { one: "{count} equipo registrado desde el endpoint", other: "{count} equipos registrados desde el endpoint" },
  "devices.velanox.standaloneRegistered": "Equipo independiente registrado: {name}",
  "devices.velanox.boxesRegistered": { one: "{count} equipo registrado", other: "{count} equipos registrados" },
  "devices.velanox.boxRegistered": "Equipo registrado",
  "devices.velanox.endpointNote": "Se ha creado un sitio para cada equipo del endpoint. Se sincronizarán automáticamente.",
  "devices.velanox.boxNote": "El equipo independiente se ha añadido como sitio.",
  "devices.velanox.registerTitle": "Registrar sitio Velanox",
  "devices.velanox.registerSubtitle": "Conecte un endpoint Velanox One Speed o un equipo independiente",
  "devices.velanox.endpoint": "Endpoint",
  "devices.velanox.endpointDesc": "Agrupa varios equipos. Crea automáticamente un sitio por equipo.",
  "devices.velanox.standalone": "Equipo independiente",
  "devices.velanox.standaloneDesc": "Un único equipo consultado directamente.",
  "devices.velanox.endpointName": "Nombre del endpoint",
  "devices.velanox.endpointNamePlaceholder": "p. ej. Endpoint Ámsterdam",
  "devices.velanox.endpointNameHint": "Se usa como etiqueta — los nombres de cada equipo vienen de la API.",
  "devices.velanox.siteNamePlaceholder": "p. ej. Unidad móvil Starlinkhuren",
  "devices.velanox.url": "URL de Velanox *",
  "devices.velanox.baseUrlEndpoint": "URL base del servidor Flask del endpoint.",
  "devices.velanox.baseUrlBox": "URL base del servidor HTTP del equipo independiente.",
  "devices.velanox.token": "Token de integración *",
  "devices.velanox.setVia": "Se define con",
  "devices.velanox.onNode": "en el nodo Velanox.",
  "devices.velanox.descriptionPlaceholder": "Notas opcionales sobre esta conexión",
  "devices.actionFailed": "Error en la acción",
  "devices.actionSent": "«{action}» enviado",
  "devices.action.reboot": "reinicio",
  "devices.action.firmware_check": "comprobación de firmware",
  "devices.action.tunnel_reconnect": "reconexión del túnel",
  "devices.action.wan_enable": "activar WAN",
  "devices.action.wan_disable": "desactivar WAN",
  "devices.action.send_sms": "enviar SMS",
  "devices.action.restart_modem": "reiniciar módem",
  "devices.action.switch_sim": "cambiar SIM",
  "devices.action.restart_network": "reiniciar red",
  "devices.action.roll_key": "renovar clave",
  "devices.action.restart_service": "reiniciar servicio",
  "devices.action.get_stats": "obtener estadísticas",
  "devices.action.fetch_logs": "obtener registros",
  "devices.action.starlink_stow": "plegar antena",
  "devices.action.starlink_unstow": "desplegar antena",
  "devices.action.starlink_reboot": "reiniciar antena",
  "devices.upFor": "activo desde hace {duration}",
  "devices.memory": "Memoria",
  "devices.temperature": "Temperatura",
  "devices.openMap": "Abrir mapa",
  "devices.controls": "Controles del dispositivo",
  "devices.checkFirmware": "Comprobar firmware",
  "devices.sendSms": "Enviar SMS",
  "devices.reboot": "Reiniciar",
  "devices.sms.recipient": "Número del destinatario",
  "devices.sms.message": "Mensaje",
  "devices.sms.charges": "Se envía desde la SIM del router. Se aplican cargos del operador.",
  "devices.signal.0": "Sin señal",
  "devices.signal.1": "Muy débil",
  "devices.signal.2": "Débil",
  "devices.signal.3": "Aceptable",
  "devices.signal.4": "Buena",
  "devices.signal.5": "Excelente",
  "devices.unknown": "desconocido",
  "devices.unknownError": "Error desconocido",
  "devices.up": "Activo",
  "devices.connected": "Conectado",
  "devices.loss": "{percent} % de pérdida",
  "devices.interface": "Interfaz",
  "devices.ipAddress": "Dirección IP",
  "devices.gateway": "Puerta de enlace",
  "devices.enable": "Activar",
  "devices.disable": "Desactivar",
  "devices.device": "Dispositivo",
  "devices.firmware": "Firmware",
  "devices.mikrotik.updateCheckDone": "Comprobación de actualizaciones terminada",
  "devices.mikrotik.installedLatest": "Instalada {installed}, última {latest}",
  "devices.mikrotik.noNewer": "No se ha comunicado ninguna versión más reciente",
  "devices.mikrotik.backupSaved": "Copia de seguridad guardada",
  "devices.mikrotik.rebootSent": "Reinicio enviado",
  "devices.mikrotik.backInMinute": "El dispositivo volverá en uno o dos minutos.",
  "devices.mikrotik.renamePrompt": "Nombre de este enlace",
  "devices.mikrotik.renameFailed": "Error al renombrar",
  "devices.mikrotik.forgetConfirm": "¿Olvidar {name}? Úselo para una estación retirada a propósito — vuelve sola si se reconecta.",
  "devices.mikrotik.forgetFailed": "No se pudo eliminar el enlace",
  "devices.mikrotik.device": "Dispositivo MikroTik",
  "devices.mikrotik.updateBadge": "actualización {version}",
  "devices.mikrotik.via": "mediante {transport}",
  "devices.mikrotik.configure": "Configurar",
  "devices.mikrotik.checkUpdates": "Buscar actualizaciones",
  "devices.mikrotik.backup": "Copia de seguridad",
  "devices.mikrotik.rebootConfirm": "¿Reiniciar este dispositivo? Los enlaces que pasan por él se cortan uno o dos minutos.",
  "devices.mikrotik.cannotReach": "No se puede contactar con el dispositivo{reason}. Los enlaces de abajo son los vistos por última vez.",
  "devices.mikrotik.links": "Enlaces",
  "devices.mikrotik.wifiClients": { one: "{count} cliente Wi-Fi", other: "{count} clientes Wi-Fi" },
  "devices.mikrotik.radioLinks": "Radioenlaces",
  "devices.mikrotik.noLinks": "Todavía no se han visto enlaces. Aparecen tras la primera sincronización en cuanto se conecta una estación.",
  "devices.mikrotik.farEnd": "Extremo remoto",
  "devices.mikrotik.signal": "Señal",
  "devices.mikrotik.rate": "Velocidad ↑ / ↓",
  "devices.mikrotik.quality": "Calidad",
  "devices.mikrotik.distance": "Distancia",
  "devices.mikrotik.roleAp": "punto de acceso",
  "devices.mikrotik.roleStation": "estación",
  "devices.mikrotik.onInterface": "en {interface}",
  "devices.mikrotik.linkDown": "enlace caído",
  "devices.mikrotik.seen": "visto {when}",
  "devices.mikrotik.rename": "Renombrar",
  "devices.mikrotik.forget": "Olvidar este enlace",
  "devices.mikrotik.noWireless": "No hay interfaces inalámbricas",
  "devices.mikrotik.mode": "Modo",
  "devices.mikrotik.channel": "Canal",
  "devices.mikrotik.state": "Estado",
  "devices.mikrotik.disabled": "desactivado",
  "devices.mikrotik.running": "activo",
  "devices.mikrotik.notConnected": "no conectado",
  "devices.mikrotik.uplinks": "Enlaces ascendentes",
  "devices.mikrotik.noUplink": "No se ha encontrado ningún enlace ascendente. Una interfaz cuenta como tal cuando está en la lista de interfaces «WAN» o lleva la ruta predeterminada.",
  "devices.mikrotik.address": "Dirección",
  "devices.mikrotik.order": "Orden",
  "devices.mikrotik.signalAria": "señal {percent} por ciento",
  "devices.peplink.cannotReach": "No se puede contactar con el dispositivo Peplink — revise las credenciales",
  "devices.peplink.wansUp": "WAN activas",
  "devices.peplink.tunnels": "Túneles SpeedFusion",
  "devices.storedLine": "Última lectura {when}: leyendo el router ahora…",
  "devices.storedLineNever": "Aún sin leer: leyendo el router ahora…",
  "devices.peplink.wanLinks": "Enlaces WAN",
  "devices.peplink.unknownCarrier": "Operador desconocido",
  "devices.peplink.rebootConfirm": "¿Reiniciar este dispositivo Peplink? Todos los enlaces se cortan durante 1-2 minutos.",
  "devices.teltonika.cannotReach": "No se puede contactar con el dispositivo Teltonika — revise las credenciales y la conectividad",
  "devices.teltonika.modems": "Módems",
  "devices.teltonika.power.title": "Alimentación",
  "devices.teltonika.power.noBattery": "Sin batería",
  "devices.teltonika.power.onMains": "Con corriente de red",
  "devices.teltonika.power.onBattery": "Con alimentación de respaldo desde {time} ({duration})",
  "devices.teltonika.power.notKnown": "Desconocida",
  "devices.teltonika.power.has": "Tiene alimentación de respaldo (SAI)",
  "devices.teltonika.power.notChanged": "No se ha cambiado el ajuste de la alimentación de respaldo",
  "devices.teltonika.noModems": "No se ha comunicado ningún módem móvil",
  "devices.teltonika.noOperator": "Sin operador",
  "devices.teltonika.band": "Banda {band}",
  "devices.teltonika.dataUsage": "Uso de datos",
  "devices.teltonika.restartModem": "Reiniciar módem",
  "devices.teltonika.switchSimConfirm": "¿Cambiar {modem} a la otra ranura SIM?",
  "devices.teltonika.switchSim": "Cambiar SIM",
  "devices.teltonika.wanInterfaces": "Interfaces WAN",
  "devices.teltonika.noWans": "No se ha comunicado ninguna interfaz WAN",
  "devices.teltonika.rebootConfirm": "¿Reiniciar este dispositivo? Estará sin conexión 1-2 minutos.",
  "devices.teltonika.vpnMode": "Programado en el banco",
  "devices.teltonika.vpnModeDesc": "Por su número de serie, con su propio certificado VPN",
  "devices.teltonika.serial": "Número de serie",
  "devices.teltonika.serialHint": "Como en su etiqueta; los espacios no importan. El mismo número de serie otra vez actualiza este router y le da un certificado nuevo.",
  "devices.teltonika.model": "Modelo",
  "devices.teltonika.modelHint": "El modelo puede quedar vacío: el router indica el suyo en su primera conexión.",
  "devices.teltonika.vpnLogin": "Inicio de sesión de Velanox en el router",
  "devices.teltonika.vpnLoginHint": "El usuario con el que Velanox inicia sesión a través del túnel. La contraseña se guarda cifrada y no se vuelve a mostrar.",
  "devices.teltonika.addRouter": "Añadir router",
  "devices.teltonika.routerAdded": "Router añadido",
  "devices.teltonika.routerAddedText": "Su certificado VPN está emitido: cargue su .ovpn en el router desde esta página.",
  "devices.teltonika.addFailed": "El router no se ha añadido",
  "devices.teltonika.vpn.waiting": "Esperando el router",
  "devices.teltonika.vpn.noAccount": "Este router aún no tiene certificado VPN: añádalo de nuevo con el mismo número de serie para emitir uno.",
  "devices.teltonika.vpn.newCertConfirm": "¿Emitir un certificado VPN nuevo para {name}? El actual deja de funcionar de inmediato; el router queda sin VPN hasta que tenga el archivo nuevo.",
  "devices.teltonika.vpn.newCertDoneText": "Descargue el .ovpn nuevo y cárguelo en el router.",
  "devices.teltonika.vpn.stepsTitle": "Cargarlo en el router (WebUI de RutOS)",
  "devices.teltonika.vpn.step1": "Services → VPN → OpenVPN: añada una instancia de cliente llamada velanox.",
  "devices.teltonika.vpn.step2": "Actívela, active «{option}» y elija {file}. Guarde.",
  "devices.teltonika.vpn.step3": "El router se conecta; esta tarjeta muestra Conectado en pocos minutos.",
  "devices.unifihost.consoleName": "Consola UniFi",
  "devices.unifihost.readOnly": "Vista en la nube de solo lectura. Para cambiar ajustes, registre el controlador local como sitio UniFi.",
  "devices.unifihost.online": "en línea",
  "devices.unifihost.offline": "sin conexión",
  "devices.unifihost.onConsole": "en esta consola",
  "devices.unifihost.connected": "conectados",
  "devices.unifihost.updates": "Actualizaciones",
  "devices.unifihost.firmwareAvailable": "firmware disponible",
  "devices.unifihost.ispPerformance": "Rendimiento del ISP",
  "devices.unifihost.last24h": "Últimas 24 h",
  "devices.unifihost.last30d": "Últimos 30 días",
  "devices.unifihost.noIsp": "No se han comunicado métricas del ISP para esta consola",
  "devices.unifihost.updateBadge": "⬆ actualización",
  "devices.velanox.cannotReach": "No se puede contactar con el equipo Velanox — revise el token de integración y la URL",
  "devices.velanox.keyRollPending": "🔑 Renovación de clave pendiente",
  "devices.velanox.wans": { one: "{count} WAN", other: "{count} WAN" },
  "devices.velanox.encrypted": "🔒 cifrado",
  "devices.velanox.na": "N/D",
  "devices.velanox.rttBonded": "RTT (agregado)",
  "devices.velanox.packetLoss": "Pérdida de paquetes",
  "devices.velanox.wanPaths": "Rutas WAN",
  "devices.velanox.noWanPaths": "No hay rutas WAN",
  "devices.velanox.jitter": "Jitter",
  "devices.velanox.loss": "Pérdida",
  "devices.velanox.weight": "Peso",
  "devices.velanox.anchor": "Ancla",
  "devices.velanox.alive": "Activo",
  "devices.velanox.roaming": "Itinerancia",
  "devices.velanox.boxControls": "Controles del equipo",
  "devices.velanox.controlsNote": "Las acciones se envían al equipo por el canal de gestión. El reinicio provoca una breve interrupción.",
  "devices.velanox.rollKey": "Renovar clave",
  "devices.velanox.restartService": "Reiniciar servicio",
  "devices.velanox.getStats": "Obtener estadísticas",
  "devices.velanox.fetchLogs": "Obtener registros",
  "devices.velanox.rebootBox": "Reiniciar equipo",
  "devices.velanox.rebootConfirm": "¿Reiniciar este equipo Velanox? Provocará una breve interrupción.",
  "devices.velanox.starlinkUnavailable": "El estado de Starlink no está disponible{reason}.",
  "devices.velanox.loadingStarlink": "Cargando el estado de Starlink…",
  "devices.velanox.noDriver": "No hay ningún controlador de Starlink conectado a este equipo. El equipo indica driver: null.",
  "devices.velanox.capabilities": "Capacidades de Starlink",
  "devices.velanox.driver": "Controlador: {driver}",
  "devices.velanox.reposition": "El reposicionamiento nunca está disponible en hardware Starlink real — las antenas se orientan solas.",
  "devices.velanox.dishControls": "Controles de la antena",
  "devices.velanox.greyedNote": "Los botones aparecen en gris cuando la antena no admite esa capacidad.",
  "devices.velanox.grpcNote": "Nota: el control de la antena mediante el endpoint devuelve 501 (integración pendiente). Use el modo de equipo independiente para controlar la antena.",
  "devices.velanox.stow": "Plegar antena",
  "devices.velanox.unstow": "Desplegar antena",
  "devices.velanox.rebootDish": "Reiniciar antena",
  "devices.velanox.rebootDishConfirm": "¿Reiniciar la antena Starlink?",
  "devices.velanox.dishStatus": "Estado de la antena",
  "devices.velanox.notSupported": "{label} no es compatible con este equipo",
  "devices.velanox.preset.firmware": "Estado del firmware",
  "devices.velanox.preset.gateway": "Estado de las puertas de enlace",
  "devices.velanox.preset.firewall": "Reglas del cortafuegos",
  "devices.velanox.preset.dhcp": "Concesiones DHCP",
  "devices.velanox.preset.interfaces": "Interfaces",
  "devices.velanox.preset.arp": "Tabla ARP",
  "devices.velanox.invalidJson": "El cuerpo no es un JSON válido",
  "devices.velanox.requestFailed": "Error en la solicitud",
  "devices.velanox.passThrough": "Paso a través de OPNsense. El equipo aplica el nivel de acceso configurado — las llamadas denegadas devuelven 403. El nivel 3 puede reiniciar o reconfigurar el cortafuegos.",
  "devices.velanox.quickPresets": "Ajustes rápidos",
  "devices.velanox.httpMethod": "Método HTTP",
  "devices.velanox.apiPath": "Ruta de la API",
  "devices.velanox.requestBody": "Cuerpo de la solicitud (JSON, opcional)",
  "devices.velanox.response": "Respuesta",
  "devices.unifihost.connectedSince": "Conectado desde",
  "devices.unifihost.managedBy": "Gestionado por",
  "devices.unifihost.mgmt.GATEWAY": "Puerta de enlace",
  "devices.unifihost.mgmt.SWITCH": "Conmutador",
  "devices.unifihost.mgmt.UNMANAGED": "No gestionado",
  "devices.unifihost.defaultNetwork": "predeterminada",
  "devices.unifihost.security": "Seguridad",
  "devices.unifihost.bands": "Bandas",
  "devices.unifihost.network": "Red",
  "devices.unifihost.nativeNetwork": "Red nativa",
  "devices.unifihost.sec.OPEN": "Abierta",
  "devices.unifihost.sec.WPA2_PERSONAL": "WPA2-Personal",
  "devices.unifihost.sec.WPA3_PERSONAL": "WPA3-Personal",
  "devices.unifihost.sec.WPA2_WPA3_PERSONAL": "WPA2/WPA3-Personal",
  "devices.unifihost.sec.WPA2_ENTERPRISE": "WPA2-Enterprise",
  "devices.unifihost.sec.WPA3_ENTERPRISE": "WPA3-Enterprise",
  "devices.unifihost.sec.WPA2_WPA3_ENTERPRISE": "WPA2/WPA3-Enterprise",
  "devices.unifihost.why.rejected": "UniFi rechazó la clave de API para esta consola. La clave debe pertenecer al propietario de la consola.",
  "devices.unifihost.why.unsupported": "Esta consola no puede proporcionar esta lista a través de la nube. Necesita UniFi OS 5.0.3 o posterior, y UniFi Network 10 o posterior para las redes y la wifi.",
  "devices.unifihost.why.busy": "UniFi está limitando las solicitudes a esta consola. Vuelva a intentarlo dentro de un minuto.",
  "devices.unifihost.why.unreachable": "La consola no respondió a través de la nube. Compruebe que está en línea.",
  "devices.unifihost.why.no_match": "Este sitio UniFi ya no está en su consola.",
  "devices.unifihost.why.failed": "UniFi no proporcionó esta lista.",
  "devices.unifilocal.open": "Cómo cambiar →",
  "devices.unifilocal.title": "Cambiar al controlador local",
  "devices.unifilocal.intro": "La consola se conecta al panel a través de su propio túnel VPN; después, el panel la lee y la modifica a través de su propio controlador. El sitio conserva su nombre, sus alertas y sus suscripciones.",
  "devices.unifilocal.noPermission": "Para cambiar se necesitan los permisos para editar sitios y gestionar la VPN.",
  "devices.unifilocal.step.account": "Cree la cuenta VPN de este sitio",
  "devices.unifilocal.step.accountText": "La cuenta da a la consola su propio certificado y una dirección fija en la red VPN de la empresa.",
  "devices.unifilocal.createAccount": "Crear cuenta VPN",
  "devices.unifilocal.creating": "Creando la cuenta…",
  "devices.unifilocal.accountReady": "Lista: dirección del túnel {ip}",
  "devices.unifilocal.accountFailed": "No se pudo crear la cuenta VPN",
  "devices.unifilocal.step.download": "Descargue el archivo VPN",
  "devices.unifilocal.step.downloadText": "El archivo .ovpn contiene el certificado propio de este sitio. Manténgalo en privado y úselo solo en esta consola.",
  "devices.unifilocal.download": "Descargar .ovpn",
  "devices.unifilocal.downloadFailed": "Error en la descarga",
  "devices.unifilocal.step.client": "Añádalo en UniFi como cliente VPN",
  "devices.unifilocal.client.1": "En UniFi Network, abra Settings → VPN → VPN Client y elija Create New.",
  "devices.unifilocal.client.2": "Tipo de VPN: OpenVPN. Póngale un nombre, por ejemplo Velanox.",
  "devices.unifilocal.client.3": "Suba el archivo .ovpn como archivo de configuración.",
  "devices.unifilocal.client.4": "Deje vacíos el usuario y la contraseña: el archivo contiene el certificado.",
  "devices.unifilocal.client.5": "No envíe tráfico por él: deje desactivados los asistentes de enrutamiento y no añada ninguna ruta de tráfico. Solo el panel usa este túnel.",
  "devices.unifilocal.client.6": "Elija Create. La conexión se establece en menos de un minuto.",
  "devices.unifilocal.waiting": "Esperando a que se conecte el túnel…",
  "devices.unifilocal.connected": "Túnel conectado",
  "devices.unifilocal.step.firewall": "Permita que el panel llegue a la consola",
  "devices.unifilocal.firewall.why": "UniFi coloca una conexión de cliente VPN en su zona External, que no llega a la propia consola. Añada una política de firewall que deje entrar al panel:",
  "devices.unifilocal.firewall.1": "UniFi Network 10: Settings → Policy Engine → Policy Table → Create New Policy. Versiones anteriores: Settings → Security → Firewall.",
  "devices.unifilocal.firewall.2": "Origen: zona External, dirección IP {ip}.",
  "devices.unifilocal.firewall.3": "Destino: zona Gateway, puerto 443 (TCP).",
  "devices.unifilocal.firewall.4": "Acción: Allow.",
  "devices.unifilocal.serverIpFallback": "la dirección de túnel del panel (la primera dirección de la red de sitios)",
  "devices.unifilocal.step.key": "Cree una clave de API local",
  "devices.unifilocal.key.1": "En UniFi Network: Settings → Control Plane → Integrations → Create API Key.",
  "devices.unifilocal.key.2": "Copie la clave: UniFi solo la muestra una vez.",
  "devices.unifilocal.step.switch": "Cambie el sitio a su controlador local",
  "devices.unifilocal.apiKey": "Clave de API local",
  "devices.unifilocal.controllerUrl": "Dirección del controlador",
  "devices.unifilocal.controllerHint": "Rellenada a partir de la dirección del túnel. Un UniFi Network Server autoalojado: https://<dirección>:8443",
  "devices.unifilocal.testSwitch": "Probar y cambiar",
  "devices.unifilocal.testing": "Probando…",
  "devices.unifilocal.done": "El sitio usa ahora su controlador local",
  "devices.unifilocal.why.rejected": "La consola rechazó esta clave de API. Cree una nueva en Control Plane → Integrations.",
  "devices.unifilocal.why.not_found": "La consola respondió, pero no en esta dirección. Un UniFi Network Server autoalojado usa https://<dirección>:8443.",
  "devices.unifilocal.why.unreachable": "La consola no respondió a través del túnel. Compruebe que el cliente VPN está conectado (paso 3) y que la política de firewall deja entrar al panel (paso 4).",
  "devices.unifilocal.why.no_vpn": "Este sitio aún no tiene dirección de túnel (paso 1).",
  "devices.unifilocal.why.failed": "La prueba no ha funcionado. Compruebe la dirección y la clave de API.",
  "devices.unifilocal.manual.intro": "Una consola UniFi OS (Dream Machine, Cloud Gateway, Cloud Key) se conecta como cliente OpenVPN con el archivo .ovpn de su sitio, subido tal cual.",
  "devices.unifilocal.manual.download": "Descargue el archivo .ovpn del sitio",
  "devices.unifilocal.manual.downloadText": "En la tabla de cuentas VPN de arriba, en la fila del sitio.",
  "devices.unifilocal.manual.add": "Añada el sitio en el panel",
  "devices.unifilocal.manual.addText": "Un sitio añadido mediante Site Manager: ábralo y elija la barra azul; con ella cambiará el sitio paso a paso. Un sitio nuevo: añada un sitio UniFi con la dirección del controlador https://<dirección del túnel>/proxy/network y la clave de API local.",
  "devices.mikrotik.vpnModeHint": "Velanox emite para la unidad su propio certificado VPN. Cárguelo en la unidad; en cuanto se conecte, Velanox la consulta a través de su túnel. Ahora no hace falta que nada sea accesible.",
  "devices.mikrotik.serial": "Número de serie",
  "devices.mikrotik.serialHint": "Como en su etiqueta; los espacios y las mayúsculas no importan. El mismo número otra vez actualiza esta unidad y le da un certificado nuevo.",
  "devices.mikrotik.unitRoleLabel": "Rol",
  "devices.mikrotik.unitRoleNone": "Ninguno",
  "devices.mikrotik.unitRole.SENDER": "Emisor",
  "devices.mikrotik.unitRole.RECEIVER": "Receptor",
  "devices.mikrotik.unitNameHint": "(opcional — si no, el número de serie)",
  "devices.mikrotik.vpnAccountHint": "La cuenta con la que Velanox inicia sesión a través del túnel. Se guarda cifrada y no se vuelve a mostrar.",
  "devices.mikrotik.addUnit": "Añadir MikroTik",
  "devices.mikrotik.unitAdded": "MikroTik añadido",
  "devices.mikrotik.unitAddedText": "Su certificado VPN está emitido: cargue sus archivos en la unidad desde esta página.",
  "devices.mikrotik.addFailed": "No se añadió el MikroTik",
  "devices.mikrotik.notDeployed.waiting": "Esperando la VPN",
  "devices.mikrotik.notDeployed.offline": "Sin conexión · no desplegado",
  "devices.mikrotik.waitingText": "La unidad aún no se ha conectado a la VPN; en cuanto se conecte, Velanox la consulta a través de su túnel.",
  "devices.mikrotik.vpn.connected": "Conectado",
  "devices.mikrotik.vpn.waiting": "Esperando la unidad",
  "devices.mikrotik.vpn.noAccount": "Esta unidad aún no tiene certificado VPN: añádala de nuevo con el mismo número de serie para emitir uno.",
  "devices.mikrotik.vpn.tunnelAddress": "Dirección del túnel",
  "devices.mikrotik.vpn.lastSeen": "Última conexión",
  "devices.mikrotik.vpn.never": "Nunca",
  "devices.mikrotik.vpn.downloadOvpn": "Descargar .ovpn",
  "devices.mikrotik.vpn.downloadP12": "Descargar .p12",
  "devices.mikrotik.vpn.newCert": "Certificado nuevo",
  "devices.mikrotik.vpn.newCertConfirm": "¿Emitir un certificado VPN nuevo para {name}? El actual deja de funcionar de inmediato; la unidad queda sin VPN hasta que tenga los archivos nuevos.",
  "devices.mikrotik.vpn.newCertDone": "Certificado nuevo emitido",
  "devices.mikrotik.vpn.newCertDoneText": "Descargue los archivos nuevos y cárguelos en la unidad.",
  "devices.mikrotik.vpn.newCertFailed": "No se emitió ningún certificado nuevo",
  "devices.mikrotik.vpn.passphrase": "Frase de contraseña de este .p12:",
  "devices.mikrotik.vpn.passphraseHint": "Se muestra una sola vez, solo para esta descarga; no se guarda. Cada descarga recibe una nueva.",
  "devices.mikrotik.vpn.passphraseWord": "frase-de-contraseña",
  "devices.mikrotik.vpn.commands": "Comandos para RouterOS 7.17 o posterior",
  "devices.mikrotik.vpn.commandsHint": "Suba ambos archivos a la unidad (Files) y pegue luego estos comandos en su terminal.",
  "devices.mikrotik.band.open": "Encender o apagar, cambiar la frecuencia",
  "devices.mikrotik.band.on": "Radio encendida",
  "devices.mikrotik.band.frequency": "Frecuencia",
  "devices.mikrotik.band.auto": "Automática",
  "devices.mikrotik.band.channel": "{mhz} MHz · canal {n}",
  "devices.mikrotik.band.followsAp": "Una estación sigue la frecuencia de su punto de acceso",
  "devices.mikrotik.band.offWarning": "{name} lleva un enlace de radio. Apagarla corta ese enlace: la unidad del otro extremo deja de ser accesible a través de él. Si esta unidad también queda aislada, vuelve a encender la radio por sí sola a los 10 minutos. ¿Apagar {name}?",
  "devices.mikrotik.band.applied": "Ajustes de radio aplicados",
  "devices.mikrotik.band.applying": "Aplicando. Si el cambio corta la conexión, puede tardar dos minutos.",
  "devices.mikrotik.band.apply": "Aplicar",
  "devices.vpnPath": "Accesible por su propia conexión VPN: tras añadirlo, cargue el .ovpn del sitio en el router como cliente OpenVPN. Ahora no hace falta que nada sea accesible.",
  "devices.vpnAdded": "Sitio añadido",
  "devices.vpnAddedText": "Cargue su .ovpn en el router; el sitio aparece en línea en cuanto se conecte",
  "devices.teltonika.sim.title": "Tarjeta SIM",
  "devices.teltonika.sim.slot": "SIM {slot}",
  "devices.teltonika.sim.active": "Activa",
  "devices.teltonika.sim.locked": "Bloqueada con PIN",
  "devices.teltonika.sim.unlocked": "Sin bloquear",
  "devices.teltonika.sim.blocked": "Bloqueada: necesita el PUK",
  "devices.teltonika.sim.unknown": "Desconocido",
  "devices.teltonika.sim.pinTries": "Intentos de PIN restantes: {count}",
  "devices.teltonika.sim.pukTries": "Intentos de PUK restantes: {count}",
  "devices.teltonika.sim.usesCompany": "PIN de la empresa",
  "devices.teltonika.sim.usesOwn": "PIN propio",
  "devices.teltonika.sim.usesOwnNote": "PIN propio · {note}",
  "devices.teltonika.sim.usesNone": "Ningún PIN conocido",
  "devices.teltonika.sim.storedMatches": "PIN guardado en el router: coincide",
  "devices.teltonika.sim.storedDiffers": "PIN guardado en el router: no coincide",
  "devices.teltonika.sim.storedUnknown": "PIN guardado en el router: desconocido",
  "devices.teltonika.sim.inactive": "No es la SIM activa: su estado es de la última vez que estuvo activa.",
  "devices.teltonika.sim.switchFirst": "Cambiar primero a esta SIM",
  "devices.teltonika.sim.lockCompany": "Bloquear con el PIN de la empresa",
  "devices.teltonika.sim.useOwn": "Usar un PIN propio",
  "devices.teltonika.sim.change": "Cambiar el PIN",
  "devices.teltonika.sim.unlock": "Desbloquear",
  "devices.teltonika.sim.unblockPuk": "Desbloquear con el PUK",
  "devices.teltonika.sim.store": "PIN guardado en el router",
  "devices.teltonika.sim.currentPin": "El PIN actual de la SIM",
  "devices.teltonika.sim.carrierHint": "una SIM nueva: el PIN del operador",
  "devices.teltonika.sim.keptHint": "vacío: el PIN que guarda Velanox",
  "devices.teltonika.sim.newPin": "PIN nuevo (de 4 a 8 dígitos)",
  "devices.teltonika.sim.simPin": "El PIN de la SIM",
  "devices.teltonika.sim.puk": "PUK (8 dígitos)",
  "devices.teltonika.sim.note": "Nota",
  "devices.teltonika.sim.noteHint": "p. ej. préstamo de …",
  "devices.teltonika.sim.toCompany": "Usar el PIN de la empresa",
  "devices.teltonika.sim.lastTryConfirm": "Queda un intento. Un PIN incorrecto bloqueará la SIM hasta que se introduzca su PUK. ¿Desea continuar?",
  "devices.teltonika.sim.doneSteps": "Hecho: {steps}",
  "devices.teltonika.sim.failedStep": "Sin hacer: {step}",
  "devices.teltonika.sim.step.change_pin": "PIN cambiado",
  "devices.teltonika.sim.step.check_on": "comprobación del PIN activada",
  "devices.teltonika.sim.step.check_off": "comprobación del PIN desactivada",
  "devices.teltonika.sim.step.unblock": "SIM desbloqueada",
  "devices.teltonika.sim.step.store": "PIN guardado en el router",
  "devices.teltonika.sim.step.read": "estado leído",
  "devices.teltonika.sim.needsDirect": "Cambiar el PIN de la SIM necesita la conexión directa o VPN del router.",
  "devices.teltonika.sim.notRead": "La tarjeta SIM se lee en la próxima sincronización.",
  "devices.teltonika.sim.pinTriesUnknown": "Intentos de PIN restantes: desconocido",
  "devices.teltonika.sim.unknownTriesConfirm": "No se pueden leer los intentos restantes: puede que sea el último, y un PIN o PUK incorrecto bloquearía la SIM. ¿Desea continuar?",
  "devices.teltonika.sim.lastPukConfirm": "Queda un intento de PUK. Un PUK incorrecto dejaría ahora la SIM inservible para siempre: solo su operador puede sustituirla. ¿Desea continuar?",
  "devices.accessFix.teltonika": "Ejecute esto una vez en el router para permitir el acceso al servidor VPN de Velanox {serverIp}: en su WebUI, en System → Maintenance → CLI, o por SSH desde la propia red del router.",
  "devices.accessFix.peplink": "Su API no ofrece esta opción: en el Web Admin del router, en System → Admin Security, permita HTTPS (puerto 443) y la dirección de origen {serverIp} (el servidor VPN de Velanox) en la conexión que usa la VPN.",
  "devices.accessFix.copy": "Copiar comando",
}

export default devices
